<template>
  <setting-scout-template-form
    :id="id"
    @submit="update"
  />
</template>

<script>
import SettingScoutTemplateForm from '@/components/organisms/SettingScoutTemplateForm'

export default {
  components: {
    SettingScoutTemplateForm
  },
  data () {
    return {
      id: Number(this.$route.params.id)
    }
  },
  methods: {
    update (message) {
      this.$http.secured.put(`/company/scout/message/templates/${this.id}`, message).then(response => {
        this.$router.push({ name: 'settingScoutTemplates' })
      })
    }
  }
}
</script>
